module.exports = __webpack_public_path__ + "img/1d8e36d.jpg";